import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var IndentRulesSupport = /*#__PURE__*/function () {
  function IndentRulesSupport(indentationRules) {
    _classCallCheck(this, IndentRulesSupport);

    this._indentationRules = indentationRules;
  }

  _createClass(IndentRulesSupport, [{
    key: "shouldIncrease",
    value: function shouldIncrease(text) {
      if (this._indentationRules) {
        if (this._indentationRules.increaseIndentPattern && this._indentationRules.increaseIndentPattern.test(text)) {
          return true;
        } // if (this._indentationRules.indentNextLinePattern && this._indentationRules.indentNextLinePattern.test(text)) {
        // 	return true;
        // }

      }

      return false;
    }
  }, {
    key: "shouldDecrease",
    value: function shouldDecrease(text) {
      if (this._indentationRules && this._indentationRules.decreaseIndentPattern && this._indentationRules.decreaseIndentPattern.test(text)) {
        return true;
      }

      return false;
    }
  }, {
    key: "shouldIndentNextLine",
    value: function shouldIndentNextLine(text) {
      if (this._indentationRules && this._indentationRules.indentNextLinePattern && this._indentationRules.indentNextLinePattern.test(text)) {
        return true;
      }

      return false;
    }
  }, {
    key: "shouldIgnore",
    value: function shouldIgnore(text) {
      // the text matches `unIndentedLinePattern`
      if (this._indentationRules && this._indentationRules.unIndentedLinePattern && this._indentationRules.unIndentedLinePattern.test(text)) {
        return true;
      }

      return false;
    }
  }, {
    key: "getIndentMetadata",
    value: function getIndentMetadata(text) {
      var ret = 0;

      if (this.shouldIncrease(text)) {
        ret += 1
        /* INCREASE_MASK */
        ;
      }

      if (this.shouldDecrease(text)) {
        ret += 2
        /* DECREASE_MASK */
        ;
      }

      if (this.shouldIndentNextLine(text)) {
        ret += 4
        /* INDENT_NEXTLINE_MASK */
        ;
      }

      if (this.shouldIgnore(text)) {
        ret += 8
        /* UNINDENT_MASK */
        ;
      }

      return ret;
    }
  }]);

  return IndentRulesSupport;
}();